import { ChartTooltipState } from "../../../../types";
import { StyledContainer } from "./style";

type Props = {
  tooltip: ChartTooltipState;
  label: string;
};

export const CustomYAxisTooltip = ({ tooltip, label }: Props) => {
  return (
    <>
      {tooltip.visible && (
        <StyledContainer
          style={{
            left: tooltip.x,
            top: tooltip.y + 8,
          }}
        >
          {label}:{" "}
          {tooltip.value
            .toString()
            .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}
        </StyledContainer>
      )}
    </>
  );
};
